<template>
    <div class="layout-people">
        <slot name="header">
            <div class="uk-section uk-section-medium uk-text-center uk-background-muted page-header">
              <div class="uk-light uk-container uk-container-small uk-text-center">

                  <router-link :to="parent.link" v-if="parent" class="text-green"><label>{{parent.menuTitle}}</label></router-link>
                  <h1 class="uk-margin-small-top">{{page.title}}</h1>

                  <slot name="summary">
                      <p class="uk-text-lead" v-if="page.summary">{{page.summary}}</p>
                  </slot>

                  <slot name="subheader"></slot>
              </div>
            </div>
        </slot>
        <div class="uk-section uk-background-white uk-section-medium" v-if="people && people.length">
            <div class="uk-container uk-container-large">

                <div class="uk-grid uk-child-width-1-2@s uk-child-width-1-3@m uk-child-width-1-4@l" uk-grid uk-height-match="target: .summary">
                    <div v-for="child in people" :key="child.urlSegment">
                        <PersonCard :person="child" />
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>
<script>
import _ from 'lodash'
import gql from 'graphql-tag'

import PersonCard from '../people/PersonCard.vue'

// GraphQL query
const readOnePageQuery = gql`
    query($url: String!) {
        readOnePage(filter: { fullPath: { eq: $url }}) {
            subpages {
                edges {
                    node {
                        title
                        link
                        subtitle
                        summary
                        image {
                            smallSquare
                            mediumSquare
                        }
                    }
                }
            }
        }
    }
`

export default {
    props: ['page', 'parent'],
    data() {
        return {
            people: {}
        }
    },
    components: {
        PersonCard
    },
    apollo: {
        readOnePage: {
            query: readOnePageQuery,
            variables() {
                return {
                    url: this.$route.path
                }
            },
            manual: true,
            result ({ data, loading }) {
                console.log(data);
                if (!loading) {
                    this.people = _.map(data.readOnePage?.subpages?.edges, "node")
                }
            },
            loadingKey: 'loading'
        }
    }
}
</script>
